export default {
	sort: 'recent',
	search: '',
	filterOptions: [],
	filters: {
		categories: [],
		goals: [],
		tags: [],
	},
	playbooks: [],
	selectedPlaybook: null,
	rules: [],
	dismissedRecommendations: [],
	recommendations: [],
	upgradeRule: '',
	upsells: [
		{
			cardType: 'upsell',
			slug: 'doneForYou',
			icon: 'svg-upsell-done',
			heading: 'Done-For-You Campaign Setup ($297 value)',
			desc: 'Our conversion experts will design 1 free campaign for you to get maximum results.',
			linkText: 'Included for FREE',
			ctaIcon: 'svg-available',
		},
		{
			cardType: 'upsell',
			slug: 'hireExpert',
			icon: 'svg-upsell-hire',
			heading: 'Hire our Specialists to Customize Any Campaign',
			desc: "When you're ready to bring in the experts, we're here to craft a high-converting campaign for you.",
			linkText: 'Learn More',
			ctaIcon: '',
		},
	],
};
